import { render, staticRenderFns } from "./ExpressOrderEditUser.vue?vue&type=template&id=fa04afec&scoped=true"
import script from "./ExpressOrderEditUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderEditUser.vue?vue&type=script&lang=js"
import style0 from "./ExpressOrderEditUser.vue?vue&type=style&index=0&id=fa04afec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04afec",
  null
  
)

export default component.exports